export class Declaration {
  constructor(sDeclarationId: number, sDeclarionFlag: boolean) {
    this.sDeclarationId = sDeclarationId;
    this.sDeclarionFlag = sDeclarionFlag;
  }
  sDeclarationId = 0;
  sDeclarionFlag = false
  sExplanation = "";
}
